// extracted by mini-css-extract-plugin
export default {"Root":"Developers_Root__R2q9o"};